import { render, staticRenderFns } from "./PlantLimitsData.vue?vue&type=template&id=b0094272&"
import script from "./PlantLimitsData.vue?vue&type=script&lang=ts&"
export * from "./PlantLimitsData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports